// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import sumBy from 'lodash/sumBy'
import moment from 'moment'
import React from 'react'
import Modal from '../../../common/modal/Modal'
import { i18n } from '../../index'
import css from './customerSales.css'
import DayRow from './DayRow'
import type { CustomerSalesReport } from './types'
import WeekSummaryRow from './WeekSummaryRow'
type Props = {
  data: Array<CustomerSalesReport>
}
export type DailySalesNote = {
  notes: string
  date: string
  salesVolume: number
  salesAmount: number
  target: number
  wastageAmount: number
}
export default class CustomerSalesTable extends React.Component<
  Props,
  {
    spotlight: DailySalesNote | null | undefined
  }
> {
  state = {
    spotlight: undefined,
  }
  clearSpotlight = () => {
    this.setState({
      spotlight: undefined,
    })
  }
  setSpotlight = (data: DailySalesNote) => () => {
    this.setState({
      spotlight: data,
    })
  }

  render() {
    const { data } = this.props
    const { spotlight } = this.state
    const totalMonthSales = {
      salesVolume: sumBy(data, 'salesVolume'),
      salesAmount: Math.round(sumBy(data, 'salesAmount')),
      totalTarget: sumBy(data, 'target'),
      totalDifference: Math.round(sumBy(data, 'salesVolume') - sumBy(data, 'target')),
    }
    return (
      <React.Fragment>
        <Modal spotlight={spotlight} clearSpotlight={this.clearSpotlight} />
        <table className={css.table}>
          <thead>
            <tr>
              <th />
              <th>{i18n.t('reporting.label.customerSales.salesVolume')}</th>
              <th>{i18n.t('reporting.label.customerSales.salesAmount')}</th>
              <th>{i18n.t('Ennuste(kpl)')}</th>
              <th>{i18n.t('Erotus')}</th>
              <th>{i18n.t('reporting.label.customerSales.notes')}</th>
            </tr>
          </thead>
          <tbody>
            <tr className={css.monthSummaryRow}>
              <td>{i18n.t('budgetPlanning.table.wholeMonth')}</td>
              <td>{totalMonthSales.salesVolume}</td>
              <td>{totalMonthSales.salesAmount}</td>
              <td>{totalMonthSales.totalTarget}</td>
              <td>{totalMonthSales.totalDifference}</td>
              <td></td>
            </tr>
            {data.map((singleDayData, index) => {
              const isSunday = moment(singleDayData.date).day() === 0
              const weekData = data.slice(Math.max(index - 6, 0), index + 1)
              return (
                <React.Fragment key={singleDayData.date}>
                  <DayRow data={singleDayData} handleSelectNote={this.setSpotlight} />
                  {isSunday && <WeekSummaryRow week={moment(singleDayData.date).week()} data={weekData} />}
                </React.Fragment>
              )
            })}
          </tbody>
        </table>
      </React.Fragment>
    )
  }
}
